import React from "react";
import HomeHero from "../components/HomeHero/HomeHero";

import AlpacaManufacturingLogo from "../assets/logos/AlpacaMS.svg";
import MSDynamicsLogo from "../assets/logos/dymanics-black.svg";

import HomeImg from "../assets/images/homeimg-01.png";

import ERPIcon1 from "../assets/icons/erp-icons-01.svg";
import ERPIcon2 from "../assets/icons/erp-icons-02.svg";
import ERPIcon3 from "../assets/icons/erp-icons-03.svg";
import ERPIcon4 from "../assets/icons/erp-icons-04.svg";
import ERPIcon5 from "../assets/icons/erp-icons-05.svg";
import ERPIcon6 from "../assets/icons/erp-icons-06.svg";

import IpadImg from "../assets/images/ipad.png";

import ERPGRaphic from "../assets/graphics/_5.png";
import StremlineImg from "../assets/graphics/streamline.png";
import PhoneImg from "../assets/images/phone-05-dark.png";
import { ContactForm } from "../components/ContactForm";
import { Helmet } from "react-helmet";

export function HomePage(props) {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Alpaca Systems | Manufacturing Software</title>
      </Helmet>
      <HomeHero />

      <div
        className="standardContainer flexCentre"
        style={{ marginBottom: "80px" }}
      >
        <img src={AlpacaManufacturingLogo} className="lucid-logo" alt="" />
        <h3 className="mainSubhead centre">
          Discover opportunities with the Alpaca Manufacturing Suite
        </h3>

        <p className="body-text ">
          Optimize operations and unleash business growth with Alpaca: an
          affordable suite of solutions that offer a holistic perspective on
          your manufacturing operations. Alpaca applications possess a powerful
          array of functionality for manufacturers that improves greatly upon
          the base functionality of business central. Including machine
          monitoring, scheduling, receiving, on-the-fly job tracking and
          planning, materials consumption, costing, quality control,
          traceability and more.
        </p>

        <div class="erp-icon-container">
          <img src={ERPIcon1} className="erp-icon" />
          <img src={ERPIcon2} className="erp-icon" />
          <img src={ERPIcon3} className="erp-icon" />
          <img src={ERPIcon4} className="erp-icon" />
          <img src={ERPIcon5} className="erp-icon" />
          <img src={ERPIcon6} className="erp-icon" />
        </div>
      </div>

      <div
        className="standardContainer flexCentre"
        style={{ marginBottom: "40px" }}
      >
        <h3 className="mainSubhead centre">
          Manufacturing is complex.
          <br />
          Software shouldn’t be.
        </h3>

        <p className="body-text ">
          Struggling to find a software that can quickly fit your manufacturing
          environment so you can spend more time focused on your business?
          Alpaca is here to help. As an ERP, CRM and software company that
          specializes in manufacturing, we understand these challenges.
          <br />
          <br />
          Manufacturing simplicity is more than our tagline: it represents years
          of dedication perfecting software engineering within our own
          manufacturing businesses and taking those learnings to develop
          solutions that are practical, efficient and realistic for growing
          businesses. We have worked with manufacturing clients across North
          America to deliver affordable solutions that identify opportunities
          for business efficiencies, that reduce costs, optimize workflows and
          increase profits in any manufacturing environment. Ready for the
          adventure? Alpaca your bags and get ready: simple solutions that won’t
          make you want to shear the wool off are at your fingertips
        </p>
        <img src={MSDynamicsLogo} className="dynamics-logo" alt="" />
      </div>

      <div className="standardContainer" style={{ marginBottom: "40px" }}>
        <h4 className="smallSubhead centre">
          Alpaca Systems is a Microsoft Dynamics Partner specializing in:
        </h4>
      </div>

      <div className="img-container">
        <img src={HomeImg} alt="" />
      </div>

      <div className="gridContainer">
        <div>
          <div className="imgBkg">
            <img src={IpadImg} className="ipadImg" />
          </div>
        </div>
        <div className="flexCentre">
          <h3 className="mainSubhead">Web Based Apps</h3>
          <p className="body-text left">
            Alpaca Modules are web based applications that interact with
            Business Central. The modules can be operated from your mobile
            device, tablet, laptop or any other device with web browser
            capability.
          </p>
        </div>
      </div>

      <div className="main">
        <div className="erp-img-container">
          <img src={ERPGRaphic} className="erp-img" />
        </div>
        <div className="text-container">
          <h3 className="smallSubhead white">
            Looking to implement an ERP program but don't know where to start?
            Alpaca is here to help.
          </h3>
          <div className="spacer"></div>
          <p className="body-text white left">
            Our common sense approach takes the frustration out of implementing
            business central and our real-world experience helps develop the
            customized ERP solution that fits your business. To ensure a smooth
            transition, we are available to train and support
            post-implementation.
          </p>
        </div>
      </div>

      <div className="streamline">
        <div>
          <img src={StremlineImg} className="illustration" />
        </div>
        <div>
          <h3 className="mainSubhead">Streamline Your Workflow</h3>
          <p className="body-text left">
            Leave the pen and paper, spreadsheets, and manual tracking methods
            behind and let Lucid take care of the tedious work. Custom software
            solutions that are tailored to your business. Get in touch with our
            sales team today!
          </p>
        </div>
      </div>

      <div className="grid-container">
        <div className="phone-container">
          <img src={PhoneImg} className="new" />
        </div>
        <div className="text-container">
          <h3
            className="mainSubhead white"
            style={{ fontSize: "24pt", lineHeight: "26pt" }}
          >
            Enhance your experience with app development and customizations to
            suit your unique needs.
          </h3>
          <div className="spacer"></div>
          <p className="body-text left white">
            Tailor your program with features such as automatic data entry that
            eliminates duplication, or increase information visibility so you
            can make data-driven decisions that tangibly improve your
            operations.
          </p>
        </div>
      </div>
      <ContactForm />
    </>
  );
}
